import { render, staticRenderFns } from "./agentManage.vue?vue&type=template&id=20b5459c&"
import script from "./agentManage.vue?vue&type=script&lang=js&"
export * from "./agentManage.vue?vue&type=script&lang=js&"
import style0 from "./agentManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports